import React from 'react';
import { ISubmitButtonProps } from './ISubmitButtonProps'
import Branding from './Branding';

const SubmitButton: React.FC<ISubmitButtonProps> = ({ label, submit, disabled, branding, resetIFrameHeight }) => {
   const handleKeyDown = (event: React.KeyboardEvent) => {
      switch (event.key) {
         case 'Enter': submit(event); break;
         default: return;
      }
   };
   return (
      <div className='submit-button-container'>
         <button className={`submit-button border${!disabled ? ' active' : ' inactive'}`} tabIndex={0} disabled={disabled} onKeyDown={(e) => handleKeyDown(e)} onClick={(e) => submit(e)}>
            {label}
         </button>
         {branding ? <Branding onload={resetIFrameHeight} /> : null}
      </div>
   );
};

export default SubmitButton;
